"use client";
import { Suspense } from "react";
import dynamic from "next/dynamic";
import { Stack, Typography } from "@mui/material";

import { observer, useStore } from "../../../service/mobx";
import MoreButton from "../../../component/Button/More";

const TaskCard = dynamic(() =>
  import("../../../component/Card/Task").then(module => module.TaskSize2)
);
const ModelCard = dynamic(() =>
  import("../../../component/Card/Model").then(module => module.ModelCardSize2)
);
const AuthorCard = dynamic(() =>
  import("../../../component/Card/User").then(module => module.CardUserSize2)
);
const VideoCard = dynamic(() =>
  import("../../../component/Card/External/Video").then(
    module => module.CardVideoSize1
  )
);
const ExternalLinkCard = dynamic(() =>
  import("../../../component/Card/External").then(
    module => module.CardExternalSize2
  )
);
const CodeCard = dynamic(() =>
  import("../../../component/Card/External").then(
    module => module.CardExternalCodeSize2
  )
);
const PaperCard = dynamic(() =>
  import("../../../component/Card/Paper").then(module => module.PaperCardSize2)
);
const TTS = dynamic(() => import("../Content/Reader/TTS"));

function Content({ tab, url, title, items, cardType, showAll = false }) {
  const { reader } = useStore();
  const selected = showAll || url.includes(tab);
  const conferenceRecommendations =
    reader.whiteLabelled && title.includes(" 20");
  const previewSize = conferenceRecommendations ? 3 : 1;
  const content = selected
    ? items
    : tab === "paper" || tab === "model"
    ? items.slice(0, previewSize)
    : [];
  const map = {
    audio: reader.article ? [TTS] : [],
    task: [TaskCard, "tag"],
    paper: [PaperCard, "paper"],
    user: [AuthorCard, "user"],
    model: [ModelCard, "model"],
    code: [CodeCard, "content"],
    video: [VideoCard, "video"],
    external: [ExternalLinkCard, "content"]
  };
  const [Card = () => null, entity = "Null"] = map[cardType] || [];
  const moreButton = selected === false && 1 < items.length;

  return content.length === 0 ? null : (
    <Stack spacing={1} mb={moreButton ? 0 : 3}>
      <Typography
        variant="labelLg"
        color="var(--surface-on-color)"
        textTransform="capitalize"
      >
        {title}
      </Typography>
      <Suspense>
        {showAll ? (
          <Stack spacing={1}>
            {content.map((content, index) => (
              <Card
                key={content.id || content.node?.id || index}
                {...{ [entity]: content }}
              />
            ))}
          </Stack>
        ) : (
          content.map((content, index) => (
            <Card
              key={content.id || content.node?.id || index}
              {...{ [entity]: content }}
              externalType={title}
            />
          ))
        )}
      </Suspense>
      {moreButton ? (
        <MoreButton url={url} count={items.length - previewSize} />
      ) : null}
    </Stack>
  );
}

export default observer(Content);
